export default () => {
  return {
    products: [], // [{ productName: string, activeCustomers: number, inactiveCustomers: number }]
    productsWithCustomers: [], // [{ id: number, name: string, description: string, status: number }]

    allCustomers: [],
    customersByProduct: [],
    customerDetails: {},
    userDataToEdit: {},
    subscriptionLevels: [],
    subscriptionTypes: [],
    selectedProduct: '',
    customerTransactionsHistory: [],
    customerSubscriptions: [],
    customerSelected: {},
    appLoading: false,
  };
};
